module.exports = __webpack_public_path__ + "img/PerfrctSportingAcademy.0b32d74f.jpeg";